import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
  TextField
} from "@mui/material";

const cellSx = {
  backgroundColor: "rgba(47, 53, 71, 0.9)",
  border: "1.5px solid #fff",
  color: "white",
  padding: "10px 8px"
};
const numberSx = {
  ...cellSx,
  textAlign: "left",
  fontWeight: 600
};

const JustCauseIPSTable = ({
  declaredSalary = 0,
  christmasBonus = 0,
  accruedVacation = 0,
  total = 0,
  onValuesChange // optional callback if needed
}) => {
  // Editable accrued vacation state (string to handle input edits)
  const [editableAccruedVacation, setEditableAccruedVacation] = useState(String(accruedVacation));

  // Sync prop changes
  useEffect(() => {
    setEditableAccruedVacation(String(accruedVacation));
  }, [accruedVacation]);

  // Handle input changes, allow empty or valid decimal input
  const handleAccruedVacationChange = (event) => {
    const val = event.target.value;
    if (val === "" || /^\d*\.?\d*$/.test(val)) {
      setEditableAccruedVacation(val);
      if (typeof onValuesChange === "function") {
        onValuesChange({
          accruedVacation: Number(val) || 0,
          declaredSalary,
          christmasBonus,
        });
      }
    }
  };

  // Recalculate total live based on editable accruedVacation
  const recalculatedTotal =
    (Number(declaredSalary) || 0) +
    (Number(christmasBonus) || 0) +
    (Number(editableAccruedVacation) || 0);

  // Format numbers for display
  const fmt = (num) =>
    num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const rows = [
    ["Salario Declarado(Mes)", fmt(declaredSalary), "Declarado a IPS, durante el último mes"],
    ["Aguinaldo", fmt(christmasBonus), "Total Aguinaldo"],
    [
      "Vacaciones Causadas",
      <TextField
        value={editableAccruedVacation}
        onChange={handleAccruedVacationChange}
        variant="standard"
        inputProps={{
          style: { color: "white", padding: "6px 8px", fontWeight: 600 },
          inputMode: "decimal",
          autoComplete: "off",
          spellCheck: false
        }}
        sx={{
          "& .MuiInputBase-input": { textAlign: "left", color: "white" },
          width: "120px"
        }}
      />,
      "Sólo si >1 año de servicio"
    ]
  ];

  return (
    <Box mt={4}>
      <Typography variant="h6" mb={2} fontWeight="bold" color="white">
        Despido con Justa Causa – IPS
      </Typography>
      <TableContainer component={Paper} sx={{ background: "rgba(47,53,71,0.9)" }}>
        <Table>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell sx={cellSx}>{row[0]}</TableCell>
                <TableCell sx={numberSx}>{row[1]}</TableCell>
                <TableCell sx={cellSx}>{row[2]}</TableCell>
              </TableRow>
            ))}
            {/* Total row */}
            <TableRow>
              <TableCell sx={{ ...cellSx, fontWeight: 700 }}>Total a Pagar</TableCell>
              <TableCell
                colSpan={2}
                sx={{
                  ...numberSx,
                  background: "rgba(34,189,110,0.15)",
                  color: "#3afa60",
                  fontWeight: "bold",
                  textAlign: "center",
                  fontSize: 20
                }}
              >
                {fmt(recalculatedTotal)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default JustCauseIPSTable;
